import React, {Component} from "react";
import {connect} from "react-redux";
import applogic from "../applogic.js";

class ModalReplies extends Component {
    static convertTime(time){
        let hrs = ~~(time / 3600);
        let mins = ~~((time % 3600) / 60);
        let secs = time % 60;
        let ret = "";
        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }
    render() {
        let replies;
        if (this.props.replies.length) {
            replies = this.props.replies.map((reply)=>{
                let url = '/v/' + reply.videoID + '?stime=' + reply.stime;
                return (
                    <div className="notification-item card">
                        <a href={url}>
                            <div className="card-header">
                                <h5 className="module-title-h5 mb-0">
                                    {reply.read?'':<span className="badge badge-danger">New</span>} At {ModalReplies.convertTime(reply.stime)} in {reply.courseID}: {reply.videoName}
                                </h5>
                            </div>
                        </a>
                        <div className="card-block">
                            <table>
                                <tr>
                                    <td>
                                        Your comment: {reply.replyee}
                                    </td>
                                    <td>
                                        <a href={url} className="text-success" data-toggle="tooltip" data-placement="top" title="Go to the webcast"><i className="fa fa-play-circle fa-3x" aria-hidden="true"/></a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Reply from <b>{reply.from}</b>: {reply.replier}
                                    </td>
                                    <td>
                                        <a href="#" className="text-danger" data-toggle="tooltip" data-placement="top" title="Delete this notification" onClick={applogic.deleteReply.bind(null, reply._id)}><i className="fa fa-trash fa-3x" aria-hidden="true"/></a>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                );
            });
        } else {
            replies = (<h5 className="module-title-h5 mb-0">No replies at the moment</h5>);
        }
        return (
            <div className="modal fade" id="modalReplies" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Replies sent to you</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {replies}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        replies: state.replies
    };
};
export default connect(mapStateToProps)(ModalReplies);


// WEBPACK FOOTER //
// ./src/componentsHeader/ModalReplies.js